/* eslint-disable @typescript-eslint/ban-types */
import { writable, derived } from 'svelte/store';
import langs from '../localization/langs.json';
import Cookies from 'js-cookie';
import { FluentBundle, FluentResource } from '@fluent/bundle';
import { translationData } from '../localization/translations/index.js';
export const availableLanguages = langs;
export const fallbackLang = 'ko';
export const excludeLanguages = (...languages) => {
    languages.forEach((l) => {
        const index = availableLanguages.findIndex((x) => x.code === l);
        if (index >= 0) {
            availableLanguages.splice(index, 1);
        }
    });
};
const registeredLangSections = [];
const langSections = ['ui-common', 'ui-footer', 'ui-search'];
export const langData = {};
export const registerTranslations = (data, sections) => {
    const sourceResources = Object.fromEntries(sections.map((x) => [x, new FluentResource(data[`en/${x}`])]));
    const buildLangBundle = (lang) => {
        const result = {};
        for (const section of sections) {
            const bundle = new FluentBundle(lang);
            setupFunctions(bundle);
            bundle.addResource(sourceResources[section]);
            const rawData = data[`${lang}/${section}`];
            const errors = bundle.addResource(new FluentResource(rawData), { allowOverrides: true });
            for (const error of errors) {
                console.warn('Fluent resource load error:', error);
            }
            result[section] = bundle;
        }
        return result;
    };
    for (const lang of langs) {
        const existingData = langData[lang.code] ?? {};
        langData[lang.code] = Object.assign(existingData, buildLangBundle(lang.code));
    }
    registeredLangSections.push(...sections);
};
const setupFunctions = (bundle) => {
    bundle._functions.FORUM_LINK = (text) => `[forumLink]${text}[/forumLink]`;
};
// export const langData: Record<string, LangData> = Object.fromEntries(
// 	langs.map((lang) => [lang.code, buildLangBundle(lang.code)])
// )
export const getLangCode = (code) => {
    const lang = availableLanguages.find((x) => x.code === code || x.aliases.includes(code));
    return lang?.code || 'ko';
};
export const currentLang = writable(getLangCode(typeof window !== 'undefined'
    ? Cookies.get('_adofaigg-lang') || window.navigator.language
    : 'en'));
const escapeHtmlTags = (str) => str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
export const translateKey = (language, rawKey, args, escape = true) => {
    let key;
    let sectionName;
    if (typeof rawKey === 'string') {
        ;
        [sectionName, key] = rawKey.split(':');
    }
    else {
        ;
        [sectionName, key] = rawKey;
    }
    const escapedArgs = Object.fromEntries(Object.entries(args).map(([k, v]) => {
        if (typeof v === 'string') {
            return [k, v.replace(/\[/g, '&#x5B;').replace(/\]g/, '&#93;')];
        }
        return [k, v];
    }));
    if (!language)
        return tryEscapeHtmlTags(escape, key);
    const lang = langData[language];
    if (!lang)
        return tryEscapeHtmlTags(escape, key);
    const section = lang[sectionName];
    if (!section)
        return tryEscapeHtmlTags(escape, key);
    let message = section.getMessage(key);
    if (!message?.value)
        message = langData[fallbackLang][sectionName].getMessage(key);
    if (!message?.value)
        return tryEscapeHtmlTags(escape, key);
    const result = section.formatPattern(message.value, escapedArgs);
    return tryEscapeHtmlTags(escape, result);
};
const tryEscapeHtmlTags = (escape, text) => {
    if (escape)
        return escapeHtmlTags(text);
    return text;
};
export const translate = (language, rawKey, args, escape = true) => {
    return derived(language, (l) => {
        return translateKey(l, rawKey, args, escape);
    });
};
registerTranslations(translationData, [...langSections]);
